<template>
  <span
    v-if="project.attributes.skip_customer"
    class="flex size-5 shrink-0 items-center justify-center rounded-md bg-gray-200"
  >
    <AppIcon
      name="regular-memo"
      class="text-gray-500"
      size="sm"
    />
  </span>
  <Avatar
    v-else
    class="shrink-0"
    size="20"
    format="square"
    :src="project.attributes.picture_login_url_m"
    :username="project.attributes.name"
  />
  <span class="truncate font-semibold">{{ project.attributes.name }}</span>
  <span
    v-if="show_units_count"
    class="shrink-0 rounded-full bg-primary-100 px-2 py-0.5 text-xs font-normal text-primary-700"
  >
    {{ $t('unit.labels.unit', { count: units_count }, units_count) }}
  </span>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  project: { type: Object, required: true },
});

// Rundle projects draw active units from the client-wide budget; fixed projects
// have their own allotment (units_count_max).
const units_count = computed(() =>
  props.project.attributes.rundle
    ? props.project.attributes.units_active_count
    : props.project.attributes.units_count_max,
);

// Sup projects have no unit level, so a unit count is meaningless.
const show_units_count = computed(() => props.project.attributes.activated && !props.project.attributes.skip_unit);
</script>
